module.exports = __webpack_public_path__ + "static/media/easy-steps-3.c48b0344.svg";